import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";
import IconSvg from "../../../../SharedComponents/IconSvg";
import { Button } from "react-bootstrap";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const HeroSectionWithButton = ({
  isImageOnRight,
  imageSrc,
  children,
  headerText,
  subHeader,
  isButtonHidden,
  isImageHidden,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <Row className="d-flex justify-content-center mx-0 mt-5">
      <Col
        xs={{ order: 0, span: 12 }}
        md={{ order: isImageOnRight ? 0 : 1, span: isImageHidden ? 10 : 5 }}
        className={"text-12 text-lg-20 align-content-center pb-4"}
      >
        {headerText && (
          <Row
            className={"mx-lg-2 mb-4 EB-Garamond fw-medium text-36 text-lg-56 text-color-primary lh-1"}
            style={{ letterSpacing: "-1px" }}
          >
            <Col>{headerText}</Col>
          </Row>
        )}

        <Row className={"mx-lg-2"}>
          <Col xs={"auto"}>
            <IconSvg icon={"landing-page-bullet"}></IconSvg>
          </Col>
          <Col style={{ color: "#626C77" }}>
            {subHeader && <Row className={"mx-0 mb-3 text-20 text-lg-24 text-black"}>{subHeader}</Row>}

            {children}
          </Col>
        </Row>
        {!isButtonHidden && (
          <Row className={"mx-lg-3 mx-0 mt-5"}>
            <Button className={"button primary  rounded-pill px-2"} onClick={() => navigate("/contact")}>
              <Row>
                <Col className={"ps-3 pe-0 align-content-center "}>{t("landing.carousel.demoButton")}</Col>
                <Col xs={"auto"}>
                  <div
                    className={"rounded-circle flex-center"}
                    style={{ backgroundColor: "#fff", width: 36, height: 36 }}
                  >
                    <IconSvg height={15} width={8} icon={"carouselArrowMirrored"} />
                  </div>
                </Col>
              </Row>
            </Button>
          </Row>
        )}
      </Col>
      {!isImageHidden && (
        <Col xs={{ order: 1, span: 12 }} md={{ order: isImageOnRight ? 1 : 0, span: 5 }}>
          <div className={"position-relative hero-gradient-bg"} style={{ padding: "3%" }}>
            <Image src={imageSrc} width="100%" />
          </div>
        </Col>
      )}
    </Row>
  );
};

export default HeroSectionWithButton;
